const React = require('react');
const ButtonBase = require('@material-ui/core/ButtonBase').default;
const IconButton = require('@material-ui/core/IconButton').default;
const CloseIcon = require('../../../icons/Close');
const ErrorIcon = require('../../../icons/Error');
const LoadingAIcon = require('../../../icons/LoadingA');


module.exports = (props) => {
  const {
    name,
  } = props;
  return (
    <div className="rlv mb10 ff$2 cA3A7AC fw5 f15 usN">
      {
        props.loading ? (
          <div className="layoutRow fhaS fvaC w h66 rlv ph22 ov r8">
            <div className="abs s r8 b2 bs bcF.08"/>
            <div
              className="abs svl ov dn"
              style={{
                width: '' + props.progress + '%',
              }}
            >
              <div className="abs svl r8 b2 bs bcDBDBDB w200%+10"/>
            </div>
            <LoadingAIcon
              className="w28 cF rlv z1 spnr"
            />
          </div>
        ) : (
          props.error ? (
            <div
              className="layoutRow fhaS fvaC rlv w h66 ov r8 bgF.12 dn
                bgF.2:h cF ph22"
            >
              <ErrorIcon className="w24"/>
              <div className="ph20 fx1 wmin0 f14">
                <div>Failed to upload file!</div>
                <div>Try again</div>
              </div>
            </div>
          ) : (
            <div
              className="layoutRow fhaS fvaS w hmin86 ov r8 bgF.12 dn rlv
                bgF.2:h"
            >
              <div className="layoutRow fhaC fvaC ph15 w90">
                <div className="sq56 mv15 ov r4 layoutRow fhaC fvaC">
                  <img
                    src={props.image}
                    className={'dB hmax.horizontal wmax.vertical '
                      + (props.hasHorizontal ? 'horizontal' : 'vertical')}
                  />
                </div>
              </div>
              <div className="pv20 f14 fx1 wmin0 pr50">
                <div>{props.label}</div>
                {
                  name ? (
                    <div
                      className="mt10 cF"
                    >{name}</div>
                  ) : null
                }
              </div>
            </div>
          )
        )
      }
      {
        props.disabled ? null : (
          <ButtonBase
            className="dB*2 abs*2 s"
            component="div"
            onClick={props.onClick}
          />
        )
      }
      <IconButton
        className="abs*2 srt5 cF*2 z1"
        onClick={props.onRemove}
      >
        <CloseIcon
          className="w18 cF"
        />
      </IconButton>
    </div>
  );
};
